export const getters = {
  getKanbans($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getKanbanById: $state => id => {
    return $state.records[Number(id)] || {};
  },
  getMyKanbans($state, $getters) {
    return $getters.getKanbans.filter(kanban => kanban.is_member);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getKanban: $state => id => {
    return $state.records[id] || {};
  },
  getStagesByKanbanId: $state => id => {
    const kanban = $state.records[Number(id)];
    return kanban
      ? [...(kanban.kanban_stages || [])].sort(
          (a, b) => a.position - b.position
        )
      : [];
  },
  getStageAutomation: $state => stageId => {
    return $state.automations[Number(stageId)] || null;
  },
};
